import Vue from "vue";

/**
 * 	LogService
 * 	
 */
export const Log = new Vue({

	methods: {

		/**
		 * 	Einen Fehler loggen
		 * 	Log.ERROR('funcName', 'message', data);
		 * 
		 */
		ERROR( caller, msg, obj ) {
			console.log( `%c ${caller}: ${msg}`, 'color: #ff2200' );
			if (obj) console.log(obj);
		},
		
		/**
		 * 	Einen Erfolg loggen
		 * 	Log.SUCCSS('funcName', 'message', data);
		 * 	
		 */
		SUCCESS( caller, msg, obj ) {
			console.log( `%c ${caller}: ${msg}`, 'color: #22aa00' );
			if (obj) console.log(obj);
		},

		/**
		 * 	Eine Info loggen
		 * 	Log.INFO('funcName', 'message', data);
		 * 	
		 */
		INFO( caller, msg, obj ) {
			console.log( `%c ${caller}: ${msg}`, 'color: #cb8524' );
			if (obj) console.log(obj);
		},

	}

});